// Mock data for HTS Janzen Hausverwaltung website

export const companyInfo = {
  name: "HTS Janzen",
  tagline: "Hausverwaltung",
  slogan: "Wir kümmern uns um Ihre Immobilie. Damit Sie es nicht tun müssen.",
  address: {
    street: "Mergelkamp 6",
    zip: "47559",
    city: "Kranenburg",
  },
  email: "s.janzen@hts-janzen.de",
  phone: "+49 1573 5188347",
  legal: "Zugelassen nach § 34c GewO · Verwaltung gemäß §§ 19, 26 ff. WEG",
};

export const navLinks = [
  { label: "Start", href: "/#start" },
  { label: "Über uns", href: "/#about" },
  { label: "WEG-Verwaltung", href: "/weg-verwaltung-kleve" },
  { label: "Verwalterwechsel", href: "/verwalterwechsel" },
  { label: "FAQ", href: "/faq" },
  { label: "Kontakt", href: "/#contact" },
];

export const heroStats = [
  { value: "10", label: "Werktage bis zur Abrechnung" },
  { value: "100%", label: "Transparenz" },
  { value: "1", label: "Fester Ansprechpartner" },
];

export const services = [
  {
    id: 1,
    icon: "Building2",
    title: "Technische Verwaltung",
    description:
      "Regelmäßige Objektbegehungen, Instandhaltung, Koordination von Handwerkern und Überwachung sämtlicher technischer Anlagen Ihrer Immobilie.",
  },
  {
    id: 2,
    icon: "Calculator",
    title: "Kaufmännische Verwaltung",
    description:
      "Erstellung von Jahresabrechnung und Wirtschaftsplan, Prüfung von Hausgeldzahlungen sowie transparente Verwaltung der Instandhaltungsrücklage.",
  },
  {
    id: 3,
    icon: "Users",
    title: "Organisatorische Verwaltung",
    description:
      "Vorbereitung, Durchführung und Protokollierung der jährlichen Eigentümerversammlung inkl. Umsetzung sämtlicher Beschlüsse.",
  },
  {
    id: 4,
    icon: "ShieldCheck",
    title: "Versicherungsmanagement",
    description:
      "Prüfung bestehender Versicherungen, professionelle Schadensabwicklung und Koordination mit Versicherern im Schadensfall.",
  },
  {
    id: 5,
    icon: "FileText",
    title: "Rechnungsprüfung",
    description:
      "Sorgfältige Prüfung aller Rechnungen, Überwachung und Abnahme von Handwerkerarbeiten sowie zuverlässige Zahlungsabwicklung.",
  },
  {
    id: 6,
    icon: "PhoneCall",
    title: "Persönliche Erreichbarkeit",
    description:
      "Direkter Ansprechpartner für alle Eigentümer, von Fragen rund um Ihre Immobilie bis hin zu pünktlichen Jahresabrechnungen und gut vorbereiteten Eigentümerversammlungen.",
  },
];

export const benefits = [
  {
    icon: "Receipt",
    title: "Transparente Abrechnungen",
    text: "Nachvollziehbare Jahresabrechnungen mit klaren Belegen. Sie wissen jederzeit, wofür Ihr Hausgeld eingesetzt wird.",
  },
  {
    icon: "Settings",
    title: "Zuverlässige Betreuung",
    text: "Kontinuierliche Wartung und schnelle Reaktion auf Objektprobleme. Ihre Immobilie ist bei uns in besten Händen.",
  },
  {
    icon: "Lightbulb",
    title: "Handwerkliches Know-how",
    text: "Erfahrung aus Handwerk und WEG-Verwaltung plus ein breites Handwerkernetzwerk. So finden wir für jedes Problem eine schnelle Lösung.",
  },
  {
    icon: "Clock",
    title: "Abrechnungsgarantie",
    text: "Wir garantieren Ihnen die Hausgeldabrechnung innerhalb von 10 Werktagen nach Eingang der Heizkostenabrechnung.",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Erstgespräch",
    text: "Kostenloses und unverbindliches Beratungsgespräch, in dem wir Sie und Ihr Objekt kennenlernen.",
  },
  {
    step: "02",
    title: "Analyse & Angebot",
    text: "Wir analysieren Ihre aktuelle Situation und erstellen ein maßgeschneidertes Verwaltungsangebot.",
  },
  {
    step: "03",
    title: "Übernahme",
    text: "Reibungslose Übernahme der Verwaltung inkl. Kommunikation mit der bisherigen Verwaltung.",
  },
  {
    step: "04",
    title: "Laufende Betreuung",
    text: "Dauerhafte, professionelle Betreuung Ihrer Immobilie mit persönlichem Ansprechpartner.",
  },
];


export const faqs = [
  {
    q: "Was kostet eine WEG-Verwaltung?",
    a: "Die Kosten hängen von Größe und Zustand der Anlage ab, etwa von der Anzahl der Einheiten, dem Instandhaltungsbedarf und dem gewünschten Leistungsumfang. Deshalb erstellen wir kein Pauschalangebot, sondern ein individuelles Angebot. Fragen Sie es unverbindlich an.",
  },
  {
    q: "Wie läuft ein Verwalterwechsel ab?",
    a: "In vier Schritten: unverbindliches Erstgespräch und Angebot, Beschluss der Eigentümerversammlung, Übernahme der Unterlagen vom bisherigen Verwalter (das erledigen wir) und Start mit festem Ansprechpartner. Seit der WEG-Reform kann der Verwalter jederzeit abberufen werden, ein Wechsel ist daher auch kurzfristig möglich.",
    link: { to: "/verwalterwechsel", label: "Zum Ablauf des Verwalterwechsels" },
  },
  {
    q: "Ab wie vielen Einheiten verwalten Sie?",
    a: "Eine Mindestgröße gibt es bei uns nicht. Unser Schwerpunkt liegt auf kleinen und mittelgroßen Eigentümergemeinschaften, für die große Verwaltungen oft kein oder nur ein unpersönliches Angebot abgeben. Gerade dort zahlt sich ein fester Ansprechpartner aus.",
  },
  {
    q: "Welche Orte betreuen Sie?",
    a: "Unser Kerngebiet ist der Kreis Kleve mit Kleve, Kranenburg, Bedburg-Hau, Goch, Emmerich am Rhein, Kalkar und Umgebung. Darüber hinaus betreuen wir Eigentümergemeinschaften am gesamten Niederrhein bis in den Raum Düsseldorf, Krefeld und Dorsten. Sprechen Sie uns gerne an, auch wenn Ihr Objekt etwas weiter entfernt liegt.",
    map: true,
  },
  {
    q: "Wie erreiche ich Sie im Notfall?",
    a: "Bei dringenden Schäden wie Rohrbruch oder Heizungsausfall erreichen Sie uns telefonisch unter +49 1573 5188347. Wir kümmern uns schnellstmöglich um die notwendigen Schritte und koordinieren die Handwerker. Bei akuter Gefahr wenden Sie sich bitte immer zuerst an Feuerwehr oder Polizei (112 bzw. 110).",
  },
  {
    q: "Welche Zulassung hat HTS Janzen?",
    a: "Wir verfügen über die gewerberechtliche Erlaubnis nach § 34c GewO und sind vermögensschadenhaftpflichtversichert.",
  },
  {
    q: "Wie schnell reagieren Sie auf Anfragen?",
    a: "E-Mails beantworten wir innerhalb von 24 Stunden. In dringenden Fällen erreichen Sie uns telefonisch.",
  },
];

export const images = {
  hero: "https://images.unsplash.com/photo-1624204386084-dd8c05e32226",
  stats: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00",
  services1: "https://images.unsplash.com/photo-1551361415-69c87624334f",
  services2: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8",
  about1: "https://images.unsplash.com/photo-1612637968894-660373e23b03",
  about2: "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=1200&q=85&fit=crop",
};
